import { render, staticRenderFns } from "./ListSetores.vue?vue&type=template&id=2133850f"
import script from "./ListSetores.vue?vue&type=script&lang=js"
export * from "./ListSetores.vue?vue&type=script&lang=js"
import style0 from "./ListSetores.vue?vue&type=style&index=0&id=2133850f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports